// extracted by mini-css-extract-plugin
export default {"logoSmall":"Login_logoSmall__kCP-T","loginMaster":"Login_loginMaster__5vB3L"};